import instance from '../axios';

// eslint-disable-next-line max-len, consistent-return
async function fetchProducts(solution: string, audience: string, industry: string) {
  try {
    const response = await instance.get('/wp/v2/products', {
      params: {
        acf_format: 'standard',
        audiences: audience,
        industries: industry,
        solutions: solution,
        per_page: 5,
      },
    });
    return response.data;
  } catch (e) {
    return false;
  }
}

export default fetchProducts;
